import styled, { css } from 'styled-components';

export const GridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	width: 100vw;
	height: 100dvh;

	@media only screen and (min-device-width: 768px) and (max-device-width: 768px) {
		grid-template-columns: minmax(50px, auto) minmax(50px, 360px);
	}

	@media only screen and (min-device-width: 820px) and (max-device-width: 820px) {
		grid-template-columns: minmax(50px, auto) minmax(50px, 360px);
	}

	@media (min-width: 1024px) {
		grid-template-columns: minmax(50px, auto) minmax(50px, 372px);
	}
`;

export const Content = styled.div`
	overflow-y: auto;
	overflow-x: hidden;
	height: 75vh;
	padding-right: 12px;
`;

export const FlexContainer = styled.div<{ $show: boolean }>`
	display: flex;
	flex-direction: column;
	height: 100dvh;

	${props =>
		!props.$show &&
		css`
			display: none;
		`}
`;

export const PanelContent = styled.div`
	height: 100dvh;
`;

export const MarginTop = styled.div`
	margin-top: 16px;
`;
